import React from 'react';
import styled, { css } from 'styled-components';
import Tippy from '@tippyjs/react';

import { isBrowser } from '@tager/web-core';

import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';
import InfoIcon from '@/assets/svg/white-info.svg';

interface Props {
  title?: string;
  minPrepayment: number;
}

function MinPrepayment({ title = 'Минимальный аванс', minPrepayment }: Props) {
  return (
    <Component>
      <Title>
        {title} {minPrepayment}%{' '}
      </Title>
      <Tippy
        content={
          <InfoBlock>Минимальный аванс составляет {minPrepayment}%</InfoBlock>
        }
        placement="bottom"
        zIndex={10001}
        interactive
        appendTo={isBrowser() ? document.body : 'parent'}
      >
        <Icon>
          <InfoIcon />
        </Icon>
      </Tippy>
    </Component>
  );
}

export default MinPrepayment;

export const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 0;
  background: linear-gradient(360deg, #ffc876 0%, #fe9c08 100%);
  box-shadow: inset 0 7px 9px #e7951b;
  border-radius: 5px;
  margin-top: 10px;
`;

export const Title = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.white};

  ${media.tablet(css`
    font-size: 14px;
  `)}
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;

  svg {
    width: 13px;
    height: 13px;
  }
`;

export const InfoBlock = styled.div`
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: ${colors.black100};

  padding: 7px;
  background: ${colors.white};
  border: 0.5px solid ${colors.gray400};
  border-radius: 8px;
  box-shadow: 0 4px 19px rgb(21 27 38 / 13%);
`;
